"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requiredError = exports.maxCharactersError = exports.minCharactersError = void 0;
exports.minCharactersError = (value) => `needs to be atleast ${value} characters long`;
exports.maxCharactersError = (value) => `needs to be less than ${value + 1} characters long`;
exports.requiredError = "required";
//# sourceMappingURL=errorMessageGenerator.js.map